import React from 'react';
import styled from 'styled-components';
import HowToRead, { SectionShell, SubHeading, EditButton, Grid, Cell, HeadCell } from './HowToRead';
import { formatPct, indicatorRows } from '../reportModel';

const RoadGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(140px, 0.8fr) repeat(3, minmax(0, 1fr));
  gap: 8px;
  font-size: 13px;
`;

const PeriodHead = styled.div`
  border-radius: 6px;
  padding: 10px 14px;
  color: ${({ theme }) => theme.colors.report.paper};
  background: ${({ $i, theme }) => [theme.colors.report.blue, theme.colors.report.brand, theme.colors.report.noteTitle][$i]};
  b { display: block; font-size: 15px; }
`;

const Area = styled.div`
  display: flex;
  align-items: center;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.report.brand};
`;

const Step = styled.div`
  padding: 10px 12px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.report.panel};
  border-left: 3px solid ${({ $i, theme }) => [theme.colors.report.blue, theme.colors.report.brand, theme.colors.report.noteTitle][$i]};
`;

const Milestone = styled.div`
  padding: 10px 12px;
  border: 1px dashed ${({ theme }) => theme.colors.report.gray};
  border-radius: 6px;
  &::before { content: '●'; color: ${({ theme }) => theme.colors.report.noteTitle}; margin-right: 6px; }
`;

export default function Roadmap({ data, narrative, t, canEdit, onEdit }) {
  if (!narrative) return null;
  const { periods, rows, milestones } = narrative.roadmap;
  return (
    <SectionShell
      id="s07"
      title={t('survey.report.section.s07')}
      actions={canEdit ? <EditButton t={t} onClick={() => onEdit('roadmap')} testId="edit-roadmap" /> : null}
    >
      <HowToRead t={t}>{t('survey.report.help.roadmap')}</HowToRead>
      <RoadGrid>
        <div />
        {periods.map((p, i) => <PeriodHead key={i} $i={i}><b>{p.label}</b>{p.subtitle}</PeriodHead>)}
        {rows.map((r, i) => (
          <React.Fragment key={i}>
            <Area>{r.area}</Area>
            {r.cells.map((c, j) => <Step key={j} $i={j}>{c}</Step>)}
          </React.Fragment>
        ))}
        <Area>{t('survey.report.milestones')}</Area>
        {milestones.map((m, i) => <Milestone key={i}>{m}</Milestone>)}
      </RoadGrid>

      <SubHeading>
        {t('survey.report.indicators')}
        {canEdit && <EditButton t={t} onClick={() => onEdit('indicators')} testId="edit-indicators" />}
      </SubHeading>
      <Grid $cols="minmax(200px, 2fr) 90px 90px 90px">
        <HeadCell>{t('survey.report.colIndicator')}</HeadCell>
        <HeadCell $align="right">{t('survey.report.colCurrent')}</HeadCell>
        <HeadCell $align="right">{t('survey.report.colTarget6')}</HeadCell>
        <HeadCell $align="right">{t('survey.report.colTarget12')}</HeadCell>
        {indicatorRows(narrative, data).map((r, i) => (
          <React.Fragment key={i}>
            <Cell>{r.label}{r.code ? ` (${r.code})` : ''}</Cell>
            <Cell $align="right" $muted>{formatPct(t, r.current)}</Cell>
            <Cell $align="right" $bold>{formatPct(t, r.target6)}</Cell>
            <Cell $align="right" $bold>{formatPct(t, r.target12)}</Cell>
          </React.Fragment>
        ))}
      </Grid>
    </SectionShell>
  );
}
